export default "__VITE_ASSET__77f9b083__"